import m from "../../geodata/es2015/mongoliaLow";
window.am4geodata_mongoliaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/mongoliaLow.js
// module id = null
// module chunks = 